module.exports = __webpack_public_path__ + "static/media/Residential_Study_Courses_m_mr.927b60c6.jpg";